import React from "react";
import TempleTimingsInfo from "./TempleTimingsInfo";

import { useTranslation } from "react-i18next";
import LanguageSelector from './LanguageSelector';

function Timing() {
    const { t } = useTranslation();
    return (
        <div>
            <div className="row banner" style={{ backgroundImage: 'url(./images/slider-1.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
            
            <div className="container" style={{ backgroundImage: 'url(./images/slider-1.jpg)', marginTop: '100px', marginBottom: '100px', padding: '0px', backgroundSize: 'cover', backgroundAttachment: 'fixed',borderRadius:'25px',boxShadow:'0px 0px 1000px maroon ',display:'flex',justifyContent:'center',alignItems:'center' }}>
                    {/* <TempleTimingsInfo /> */}

                    

<div class="container-" style={{margin:'50px',width:'80%'}}>
{/* <div class="header-">പൂജാ സമയം</div> */}
{/* <!-- Subrahmanya Temple --> */}
<div class="card-1">
<h2 style={{fontFamily:'manjari'}}>{t("templsub")} </h2>

<div class="section-title">{t("mor")} </div>
<div class="time-row"><span>{t("opm")} </span><span>04:00</span></div>
<div class="time-row"><span>{t("abkk")} </span><span>04:15 - 04:45</span></div>
<div class="time-row"><span>{t("ushash")} </span><span>05:30 - 06:00</span></div>
<div class="time-row"><span>{t("kaus")} </span><span>10:30 - 11:15</span></div>
<div class="time-row"><span>{t("nadad")} </span><span>12:30</span></div>

<div class="section-title">{t("even")} </div>
<div class="time-row"><span>{t("opm")} </span><span>04:15</span></div>
<div class="time-row"><span>{t("deepau")} </span><span>07:20 - 08:00</span></div>
<div class="time-row"><span>{t("nadad")} </span><span>08:00</span></div>



<div class="highlight">
{t("snsp")} <br />
{t("prsad")} 
</div>
</div>

{/* <!-- Ayyappa Temple --> */}
<div class="card-1">
<h2 style={{fontFamily:'manjari'}}>{t("ayyapat")} </h2>

<div class="section-title">{t("mor")} </div>
<div class="time-row"><span>{t("opm")} </span><span>04:30</span></div>
<div class="time-row"><span>{t("abkk")} </span><span>04:45 - 05:15</span></div>
<div class="time-row"><span>{t("ushpoo")} </span><span>06:00 - 06:30</span></div>
<div class="time-row"><span>{t("uchpoo")} </span><span>10:00 - 11:30</span></div>
<div class="time-row"><span>{t("nadad")} </span><span>12:30</span></div>

<div class="section-title">{t("even")} </div>
<div class="time-row"><span>{t("opm")} </span><span>04:30</span></div>
<div class="time-row"><span>{t("dheebef")} </span><span>07:00 - 07:30</span></div>
<div class="time-row"><span>{t("nadad")} </span><span>07:30</span></div>

</div>

</div>
                

            </div>
        </div>
    );
}

export default Timing;